// removed by extract-text-webpack-plugin
module.exports = {"chooseRegion":"_3DJ5TIzl0KMsMZSX_FbUd1","regionsList":"Bfgr8H5OMLQAIw_EARl1V","chosen":"_2FdbWlJ4aBqch6xAnLfj_U","over":"qzjm4scZB_H7lyX_3WMY5","regionsMap":"_349vl5mbAQydCmcZZHn18e","chosenRegion":"qknNlT2ur59KE-suhzeHW","mapOver":"lkHu9kUlhOgXt5YBgFFoM","button":"_2W7JzxVqpth1OQtzHEPB1z","disabled":"dgV9bdWj_SOJDPKIClE_D","mapButton":"jWOYN-QSXoKJT2tg8FY24","disabledRegion":"_1cBcVdi8GZun8EkzLd2xOX"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/EquipComponents/ChooseRegion/index.css
// module id = 250
// module chunks = 0